import { pluralize, PluralWordForms } from '@libs/i18n';
import { Badge } from '@ui/components/Badge';

import { OneOnOneSettings, SwissSettings, TournamentSystem } from '@features/shared/api/typings';

const gamesPlural: PluralWordForms = {
  one: ':\u00A0{number}\u00A0партия',
  few: ':\u00A0{number}\u00A0партии',
  many: ':\u00A0{number}\u00A0партий',
};

const roundsPlural: PluralWordForms = {
  one: ':\u00A0{number}\u00A0тур',
  few: ':\u00A0{number}\u00A0тура',
  many: ':\u00A0{number}\u00A0туров',
};

const systems: { [k in TournamentSystem]: string } = {
  RoundRobin: 'Круговая\u00A0система',
  Swiss: 'Швейцарская\u00A0система',
  Knockout: 'Система\u00A0Нокаут',
  OneOnOne: 'Матч',
  Seance: 'Сеанс\u00A0одновременной\u00A0игры',
};

type Props = {
  tournament?: {
    system: TournamentSystem;
    oneOnOneSettings?: OneOnOneSettings;
    swissSettings?: SwissSettings;
  };
};

export function TournamentSystemBadge({ tournament }: Props) {
  if (!tournament) return null;

  let gamesCount;
  if (tournament.system === 'OneOnOne' && tournament.oneOnOneSettings) {
    gamesCount = pluralize(gamesPlural, tournament.oneOnOneSettings.gamesCount);
  }
  if (tournament.system === 'Swiss' && tournament.swissSettings?.roundsCount) {
    gamesCount = pluralize(roundsPlural, tournament.swissSettings?.roundsCount);
  }

  return (
    <Badge size="m" flat>
      {systems[tournament.system]}&nbsp;
      {gamesCount}
    </Badge>
  );
}
